<template>
  <div id="signUpWrapper">
    <div class="columns is-centered">
      <div class="column is-one-quarter">
        <div id="signin" class="card">
          <header class="card-header">
            <p class="card-header-title">Aanmelden</p>
          </header>

          <div class="card-content">
            <div class="notification is-danger" :class="{ 'is-hidden': !showAlert }">
              Logingegevens ongeldig
            </div>
            <form>
              <div class="field">
                <label for="email" class="label">E-mail adres</label>
                <div class="control">
                  <input class="input" type="text" name="email" v-model="auth.email">
                </div>
              </div>

              <div class="field">
                <label for="password" class="label">Wachtwoord</label>
                <div class="control">
                  <input class="input" type="password" name="password" v-model="auth.password">
                </div>
              </div>
            </form>

            <p><router-link :to="{ name: 'recover-account', params: { email: email } }">Ik ben m'n wachtwoord vergeten</router-link></p>
          </div>

          <footer class="card-footer">
            <a
              class="button is-text card-footer-item"
              @click="signIn"
              :class="{ 'is-loading': inProgress }"
              :disabled="disableSend">
              Verzenden
            </a>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { bus } from '@/main'

  export default {
    data () {
      return {
        auth: {
          'email': null,
          'password': null
        },
        inProgress: false,
        showAlert: false
      }
    },
    created () {
      if (this.isLoggedIn)
        this.goToAccount()
    },
    mounted () {
      let self = this

      bus.$on('invalidLogin', function () {
        self.showAlert = true
        self.inProgress = false
      })
    },
    computed: {
      sendButtonClass () {
        return this.validForm ? 'is-success' : 'is-danger'
      },
      disableSend () {
        return this.validForm ? false : true
      },
      isAuthenticating () {
        return this.$store.getters.isAuthenticating
      }
    },
    methods: {
      validForm () {
        return true
      },
      signIn () {
        this.inProgress = true
        this.$store.dispatch('signIn', this.auth).then(() => {
          this.$store.dispatch('getAccountData').then(() => {
            if (this.$store.getters.accountData.level_id === 1) {
              this.goToAdmin()
            } else {
              this.goToAccount()
            }
          })
        })
      },
      goToAccount () {
        this.$router.push('account')
      },
      goToAdmin () {
        this.$router.push('items')
        location.reload()
      }
    }
  }
</script>

<style scoped>
  #signin {
    top: 50%;
  }

  .button.is-text {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/Signin.vue